import React from "react";
import "../styles/Help.css";
import SupportDocs from "./SupportDocs";
import { useTranslation } from "../context/TranslationContext";
import SupportVideos from "./SupportVideos";
import Breadcrumb from "./Breadcrumb";
import { useAuth } from "../context/AuthContext";

const Help = () => {
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();

  const handleBack = () => {
    window.history.back();
  };
  return (
    <>
      <div className="help-container">
        {isLoggedIn && (
          <Breadcrumb
            items={[
              { label: t("breadcrumb.home"), link: "/" },
              { label: t("breadcrumb.help") },
            ]}
          />
        )}
        <SupportDocs />
        <SupportVideos />
        <div onClick={handleBack} className="link mt-20">
          {t("back")}
        </div>
      </div>
    </>
  );
};

export default Help;
